<template>
<div class="vx-col md:w-full sm:w-auto">
    <div class="vx-row md:w-full">
        <vx-tooltip class="position-icon" text="Nội dung" position="top">
            <feather-icon icon="EyeIcon" class="action-success icon-btn"
                          svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="popupFullMessage = true"/>
        </vx-tooltip>
    </div>

    <vs-popup class="holamundo"  title="Nội dung tin nhắn" :active.sync="popupFullMessage" id="show_full_message">
        <div class="vx-row">
            <div class="vx-col w-full">
                <label class="vs-input--label">Nội dung</label>
                <vs-textarea class="w-full" v-model="params.data.message"/>
            </div>
        </div>
    </vs-popup>
</div>
</template>

<script>
export default {
    name: "CellRendererActions",
    data() {
        return {
            popupFullMessage: false,
        }
    },
}
</script>

<style lang="scss">
#show_full_message {
    z-index: 55000 !important;

    .vs-textarea {
        height: 200px;
    }
}
</style>
